import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { processInt, valdiatePage } from "../../global";
import { setLoading } from "../../redux/appSlice";
import { getAccountServices, getAllServices, getLocations, saveLocationShop, saveService } from "../../services/userservice";

const LocationShops = () => {

    const dispatch = useDispatch();
    const { userInfo, accounts, subaccounts } = useSelector(state => state.appData);

    const history = useHistory();

    const d = {
        subAccountId: '',
        locationId: '',
        shopId: ''
    }

    const [data, setData] = useState(d);
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        if (valdiatePage('/locationshops')) {

        } else {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSave = async () => {
        if (!data.subAccountId) {
            alert('Select Sub Account');
            return;
        }
        if (!data.locationId) {
            alert('Select Location');
            return;
        }

        const z = {
            locationId: +data.locationId,
            shopId: +data.shopId,
            userid: +userInfo.id,
        }
        dispatch(setLoading({ data: true }));
        const rs = await saveLocationShop(z)
        dispatch(setLoading({ data: false }));

        alert(rs.msg);
        if (rs.ok) {
            setData(d);
            setLocations([]);
        }
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Location Shops</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-3">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        setData({ ...data, subAccountId: val, locationId: '' });
                        if (val) {
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            const locs = await getLocations(userInfo.id, accno)
                            if (locs)
                                setLocations(locs);
                        } else {
                            setLocations([]);
                        }
                    }}>
                        <option value="" data-accno="">Select Sub Account</option>
                        {
                            subaccounts.map((x, index) => <option key={index} value={x.id} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-3">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-3">
                    <label>Enter Shop Id</label>
                    <input type="text" className="form-control" onInput={processInt} value={data.shopId} onChange={(e) => updateData('shopId', e.target.value)} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col" style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-primary" onClick={onSave}>Save</button>
                </div>
            </div>
        </div>
    </section>
}

export default LocationShops;